import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreateChatPromptDto } from "@/dto/ChatPromptDto";
import { superChatPromptApi } from "@/apis/superChatPrompt";
import Router from "@/constants/router";

/**
 * 채팅 프롬프트 생성 페이지 Hook
 * @description 채팅 프롬프트 생성 로직을 관리합니다.
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-16
 */
export default function useCreatePrompt() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  /**
   * 프롬프트 생성 제출 핸들러
   */
  const handleSubmit = async (data: CreateChatPromptDto) => {
    setIsLoading(true);
    try {
      console.log("[CREATE_PROMPT]", {
        action: "submit",
        data,
        timestamp: new Date().toISOString(),
      });

      // API 호출로 프롬프트 생성
      const result = await superChatPromptApi.create(data);

      console.log("[CREATE_PROMPT]", {
        action: "success",
        message: "프롬프트가 성공적으로 생성되었습니다.",
        result,
      });

      alert("프롬프트가 성공적으로 생성되었습니다.");

      // 성공 시 목록 페이지로 이동
      navigate(Router.SuperChatContent);
    } catch (error: any) {
      console.error("[CREATE_PROMPT]", {
        action: "error",
        error: error.message,
        data,
      });

      // 에러 처리
      alert(`프롬프트 생성 실패: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    handleSubmit,
  };
}
